export default "__VITE_ASSET__DoeAiLN1__"